export default __webpack_public_path__ + "29f2bba8b55d0f2ae671f4e5fa1533a7.png";